"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const policy_1 = require("../policy");
const broker_1 = __importDefault(require("../broker"));
const user_1 = __importDefault(require("../../user"));
class BasePolicy {
    constructor(data) {
        this.policyNumber = data.policyNumber;
        this.type = data.type;
        this.region = data.region;
        this.user = data.user;
        this.partnerId = data.partnerId;
        this.partnerIds = data.partnerIds;
        this.broker = data.broker;
        this.status = data.status;
        this.createdBy = data.user.email;
        this.sandbox = data.sandbox;
        this.projectId = data.projectId;
        this.sanctionsChecks = data.sanctionsChecks;
        this.createdDate = data.createdDate;
        this.lastModifiedDate = data.lastModifiedDate;
        this.lastModifiedBy = data.lastModifiedBy;
        this.docs = data.docs || [];
        this.underwriterInfo = data.underwriterInfo || [];
        this.dealNumber = data.dealNumber;
        this.googleDriveDealFolderId = data.googleDriveDealFolderId;
        this.submissionDate = data.submissionDate;
        this.effectiveDate = data.effectiveDate;
    }
    static empty() {
        return new BasePolicy({
            policyNumber: "",
            type: policy_1.ePolicyType.OCEAN_CARGO,
            region: undefined,
            user: user_1.default.empty(),
            partnerId: "",
            partnerIds: [],
            broker: broker_1.default.empty(),
            status: policy_1.ePolicyStatus.UW_REVIEW,
            sandbox: false,
            projectId: "",
            sanctionsChecks: [],
            docs: [],
            underwriterInfo: [],
            dealNumber: "",
            googleDriveDealFolderId: "",
            effectiveDate: undefined
        });
    }
    static create(data) {
        return new BasePolicy({
            policyNumber: data.policyRequest.policyNumber,
            type: data.policyRequest.type,
            region: data.policyRequest.region,
            user: data.policyRequest.user,
            partnerId: data.policyRequest.partnerId,
            partnerIds: data.partnerIds,
            broker: data.policyRequest.broker,
            status: data.policyRequest.status,
            sandbox: data.sandbox,
            projectId: data.projectId,
            sanctionsChecks: data.sanctionsChecks,
            createdDate: new Date(),
            docs: [],
            underwriterInfo: [],
            effectiveDate: data.policyRequest.effectiveDate
        });
    }
    static fromObj(data) {
        if (!data) {
            return BasePolicy.empty();
        }
        return new BasePolicy({
            policyNumber: data.policyNumber,
            type: data.type,
            region: data.region,
            user: user_1.default.fromObj(data.user),
            partnerId: data.partnerId,
            partnerIds: data.partnerIds,
            broker: broker_1.default.fromObj(data.broker),
            status: data.status,
            sandbox: data.sandbox,
            projectId: data.projectId,
            sanctionsChecks: data.sanctionsChecks,
            createdDate: data.createdDate,
            lastModifiedDate: data.lastModifiedDate,
            lastModifiedBy: data.lastModifiedBy,
            docs: data.docs || [],
            underwriterInfo: data.underwriterInfo || [],
            dealNumber: data.dealNumber,
            googleDriveDealFolderId: data.googleDriveDealFolderId,
            submissionDate: data.submissionDate,
            effectiveDate: data.effectiveDate
        });
    }
    static getPolicyPathFromId(productId, type) {
        return type
            ? `/${type}/details/${productId}`
            : `/policy/details/${productId}`;
    }
    get productValidationPath() {
        return BasePolicy.getPolicyPathFromId(this.policyNumber);
    }
    static getPolicyPdfFilenameFromNumber(policyNumber) {
        return `Loadsure - Policy Request - ${policyNumber}.pdf`;
    }
    static getPolicyPdfApiPathFromNumber(policyNumber) {
        return `external/${policyNumber}/pdf/${BasePolicy.getPolicyPdfFilenameFromNumber(policyNumber)}`;
    }
}
exports.default = BasePolicy;
//# sourceMappingURL=basePolicy.class.js.map